<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="fabricCode"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :cell-class-name="cellClassName"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <span>{{ row.fabricName }}</span>
        <br />
        <span>{{ row.fabricNameEn }}</span>
        <br />
        <span>NO:</span><span>{{ row.fabricNo }}</span>
      </template>
      <template v-slot:widUnit="{ row }">
        <span>{{ $l('form_label_width') || '门幅' }}：</span
        ><span>{{ row.wid }} {{ row.v_widUnit }}</span>
        <br />
        <span>{{ $l('form_label_weight') || '克重' }}：</span
        ><span>{{ row.fabricWeight }} {{ row.v_fabricWeightUnit }}</span>
      </template>
      <template v-slot:fabricContent="{ row }">
        <span>{{ row.fabricContent }}</span>
        <br />
        <span>{{ row.fabricContentEn }}</span>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.fabricStatus === 'Y'
              ? 'success'
              : row.fabricStatus === 'D'
              ? 'danger'
              : ''
          "
        >
          {{ row.v_fabricStatus }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  mixins: [EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    tableHeight: { type: Number, default: 300 },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {},
  methods: {
    cellClassName({ column }) {
      return column.property === 'checkbox' ? '' : 'align-top'
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
    },
  },
}
</script>

